import { atom } from "recoil"

export const contactReplyThreadRequestIdState = atom<number>({
  key: "atoms/contact/contactReplyThreadRequestIdState",
  default: 0,
})
